<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><a id="a4"></a><span class="t1">Shorts</span></p>
<p class="p0">Gay Erotic Romance Box Set</p>
<p class="p0">14 Short Stories in 1 Collection!</p>
<p class="p0">By J.M. Snyder</p>
<p class="p0"><span class="t7"> </span></p>
<p class="p0"><span class="t7">Table of Contents:</span></p>
<p class="p2"><a id="a6"></a><a href="#/005#a21">Joy Ride</a></p>
<p class="p2"><a href="#/006#a22">A Little Something for Santa</a></p>
<p class="p2"><span href="#/007#a23" title="Link target outside of Sample">Poolside</span></p>
<p class="p2"><span href="#/008#a24" title="Link target outside of Sample">Pony Play</span></p>
<p class="p2"><span href="#/009#a25" title="Link target outside of Sample">Escape</span></p>
<p class="p2"><span href="#/010#a26" title="Link target outside of Sample">Best Friends</span></p>
<p class="p2"><span href="#/011#a27" title="Link target outside of Sample">One of Us</span></p>
<p class="p2"><span href="#/012#a28" title="Link target outside of Sample">Threesome</span></p>
<p class="p2"><span href="#/013#a29" title="Link target outside of Sample">Easily Addicted</span></p>
<p class="p2"><span href="#/014#a30" title="Link target outside of Sample">Hooking Up</span></p>
<p class="p2"><span href="#/015#a31" title="Link target outside of Sample">Devilish Good Time</span></p>
<p class="p2"><span href="#/016#a32" title="Link target outside of Sample">Battle of the Bands</span></p>
<p class="p2"><span href="#/017#a33" title="Link target outside of Sample">Office Visit</span></p>
<p class="p2"><span href="#/018#a34" title="Link target outside of Sample">The New Client</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?571575d4